export default __webpack_public_path__ + "static/media/datacom.72ba0457.jpg";